/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParentAttributionDto
 */
export interface ParentAttributionDto {
    /**
     * 
     * @type {number}
     * @memberof ParentAttributionDto
     */
    parentId: number;
}

/**
 * Check if a given object implements the ParentAttributionDto interface.
 */
export function instanceOfParentAttributionDto(value: object): value is ParentAttributionDto {
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    return true;
}

export function ParentAttributionDtoFromJSON(json: any): ParentAttributionDto {
    return ParentAttributionDtoFromJSONTyped(json, false);
}

export function ParentAttributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentAttributionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'parentId': json['parent_id'],
    };
}

export function ParentAttributionDtoToJSON(json: any): ParentAttributionDto {
    return ParentAttributionDtoToJSONTyped(json, false);
}

export function ParentAttributionDtoToJSONTyped(value?: ParentAttributionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parent_id': value['parentId'],
    };
}

